import { useContext } from 'react'

import { FormContext, FormContextValue } from '@f/elements/FormWrapper/Context'

const DEFAULT_CONTEXT_VALUE = {
  formElements: []
}

export const useFormContext = (): FormContextValue => {
  const formContext = useContext<FormContextValue | undefined>(FormContext)

  if (!formContext) {
    return DEFAULT_CONTEXT_VALUE
  }

  return formContext
}
